import { COPPER } from "../constants/globals"

export function countType(layers, type) {
  return layers
    .reduce((acc, cur) => cur.type === type ? acc + 1 : acc, 0 );
}

export function findCommonMhzs(layers) {
  const dielectricConstants = layers
    .filter(layer => layer.type !== COPPER)
    .map(layer => layer.dk);

  // Extract avaiable frequencies(mhz)
  const mhzFrequencies = dielectricConstants
    .reduce((freqs, dks) => {
      const mhzs = dks.map(dk => dk.mhz)
      mhzs.forEach(mhz => freqs[mhz] = freqs[mhz] ? freqs[mhz] + 1 : 1)
      return freqs;
    }, {})

  // Exclude frequencies that didn't occurs on all of the dielectric materials
  Object.keys(mhzFrequencies).forEach(mhz => {
    if (mhzFrequencies[mhz] < dielectricConstants.length) {
      delete mhzFrequencies[mhz];
    }
  });

  // create an array of mhzs
  const mhzs = Object.keys(mhzFrequencies).map(mhz => Number(mhz));

  return mhzs;
}



// WEBPACK FOOTER //
// ./src/lib/layers.js